import { isEmpty } from 'lodash';
import { MessageLabelProps } from '@zonofi/chats-common';
import React from 'react';
import { theme } from '@zonofi/common';

export const MessageLabel: React.FC<MessageLabelProps> = ({ text }) => {
  if (isEmpty(text)) return null;
  return (
    <div className="message-tag">
      <span
        className="tag-text comms-font-size-small"
        style={theme.fontConfig.semiBold}
      >
        {text}
      </span>
    </div>
  );
};
